module.exports = __webpack_public_path__ + "media/home/close_icon-1614b19b.svg";